import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

import { isFirstInGroup as isFirstInGroupHelper, highlightQuery as highlightQueryHelper } from './AutosuggestInputHelper';

import './AutosuggestInputDropdown.scss';

export default class AutosuggestInputDropdown extends React.PureComponent {
  selectMatch(index) {
    const { onSelect } = this.props;
    onSelect(index);
  }

  _isFirstInGroup(index) {
    const { matches, groupBy } = this.props;
    return isFirstInGroupHelper({ matches, index, groupBy });
  }

  _highlightMatch(match) {
    const { query } = this.props;
    return highlightQueryHelper({ string: match.title, query });
  }

  render() {
    const { matches, groupBy, highlight } = this.props;

    return (
      <div className="react-autosuggest-input-dropdown react-autosuggest-input-dropdown--absolute">
        <span className="sr-only">10 search suggestions, use up and down arrow keys to navigate.</span>
        {/* eslint-disable jsx-a11y/click-events-have-key-events,react/no-array-index-key,jsx-a11y/role-has-required-aria-props */}
        {/* eslint-disable jsx-a11y/anchor-is-valid,react/jsx-no-script-url,no-script-url */}
        <ul className="e2e-quick-search-suggest-list react-autosuggest-input-dropdown__list" role="listbox">
          {matches.map((match, index) => (
            <li
              key={index}
              onClick={() => {
                this.selectMatch(index);
              }}
              role="option">
              {groupBy && this._isFirstInGroup(index) && (
                <div className="react-autosuggest-input-dropdown__list__category">{match[groupBy]}</div>
              )}
              <a
                className="els-btn els-btn-link els-btn-sm react-autosuggest-input-dropdown__list__link key-navigatable"
                href="null"
                onClick={(e) => {
                  e.preventDefault();
                }}>
                <InnerHTML
                  tag="span"
                  className="react-autosuggest-input-dropdown__list__link__text u-els-ellipsis"
                  html={highlight ? this._highlightMatch(match) : match.title}
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

AutosuggestInputDropdown.propTypes = {
  query: PropTypes.string,
  matches: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  groupBy: PropTypes.string,
  highlight: PropTypes.bool,
};
